/**
 * Text decoration type
 * @name TextDecorationType
 */
export var TextDecorationType;
(function (TextDecorationType) {
    TextDecorationType["AUTO"] = "auto";
    TextDecorationType["UNDERLINE"] = "underline";
    TextDecorationType["NONE"] = "none";
})(TextDecorationType || (TextDecorationType = {}));
//# sourceMappingURL=decoration.js.map